import { jsx as a } from "react/jsx-runtime";
var e = "_root_cc24m_1", i = { root: e }, l = ({ children: r }) => /* @__PURE__ */ a("span", {
  className: i.root,
  children: r
}), o = (r) => {
  (r.key === "Enter" || r.key === " ") && (r.preventDefault(), r.currentTarget.click());
};
export {
  l as n,
  o as t
};
